import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftOneDriveIcon2025Present = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "35.98 139.2 648.03 430.85",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial0",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(130.864814,156.804864,-260.089994,217.063603,48.669602,228.766494)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(28.235294%,58.039216%,99.607843%)",
					stopOpacity: 1
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .695072,
				style: {
					stopColor: "rgb(3.529412%,20.392157%,70.196078%)",
					stopOpacity: 1
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial1",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(-575.289668,663.594003,-491.728488,-426.294267,596.956501,-6.380235)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .165327,
				style: {
					stopColor: "rgb(13.72549%,75.294118%,99.607843%)",
					stopOpacity: 1
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .534,
				style: {
					stopColor: "rgb(10.980392%,56.862745%,100%)",
					stopOpacity: 1
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial2",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(-136.753383,-114.806698,262.816935,-313.057562,181.196995,240.395994)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(100%,100%,100%)",
					stopOpacity: .4
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .660528,
				style: {
					stopColor: "rgb(67.843137%,75.294118%,100%)",
					stopOpacity: 0
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial3",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(-153.638428,-130.000063,197.433014,-233.332948,375.353994,451.43549)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(1.176471%,22.745098%,80%)",
					stopOpacity: 1
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				style: {
					stopColor: "rgb(21.176471%,55.686275%,100%)",
					stopOpacity: 0
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial4",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(175.585899,405.198026,-437.434522,189.555055,169.378495,125.589294)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .592618,
				style: {
					stopColor: "rgb(20.392157%,39.215686%,89.019608%)",
					stopOpacity: 0
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				style: {
					stopColor: "rgb(1.176471%,22.745098%,80%)",
					stopOpacity: .6
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial5",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(-459.329491,459.329491,-719.614455,-719.614455,589.876499,39.484649)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(29.411765%,99.215686%,90.980392%)",
					stopOpacity: .898039
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .543937,
				style: {
					stopColor: "rgb(29.411765%,99.215686%,90.980392%)",
					stopOpacity: 0
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear0",
			gradientUnits: "userSpaceOnUse",
			x1: 29.999701,
			y1: 37.9823,
			x2: 29.999701,
			y2: 18.398199,
			gradientTransform: "matrix(15,0,0,15,0,0)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(0%,52.54902%,100%)",
					stopOpacity: 1
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .49,
				style: {
					stopColor: "rgb(0%,73.333333%,100%)",
					stopOpacity: 1
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial6",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(273.622108,108.513684,-205.488428,518.148261,296.488495,307.441492)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(100%,100%,100%)",
					stopOpacity: .4
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .785262,
				style: {
					stopColor: "rgb(100%,100%,100%)",
					stopOpacity: 0
				}
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "radial7",
			gradientUnits: "userSpaceOnUse",
			cx: 0,
			cy: 0,
			fx: 0,
			fy: 0,
			r: 1,
			gradientTransform: "matrix(-305.683909,263.459223,-264.352324,-306.720147,674.845505,249.378004)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: {
					stopColor: "rgb(29.411765%,99.215686%,90.980392%)",
					stopOpacity: .898039
				}
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .584724,
				style: {
					stopColor: "rgb(29.411765%,99.215686%,90.980392%)",
					stopOpacity: 0
				}
			})]
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial0)"
				},
				d: "M 215.078125 205.089844 C 116.011719 205.09375 41.957031 286.1875 36.382812 376.527344 C 39.835938 395.992188 51.175781 434.429688 68.941406 432.457031 C 91.144531 429.988281 147.066406 432.457031 194.765625 346.105469 C 229.609375 283.027344 301.285156 205.085938 215.078125 205.089844 Z M 215.078125 205.089844 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial1)"
				},
				d: "M 192.171875 238.8125 C 158.871094 291.535156 114.042969 367.085938 98.914062 390.859375 C 80.929688 419.121094 33.304688 407.113281 37.25 366.609375 C 36.863281 369.894531 36.5625 373.210938 36.355469 376.546875 C 29.84375 481.933594 113.398438 569.453125 217.375 569.453125 C 331.96875 569.453125 605.269531 426.671875 577.609375 283.609375 C 548.457031 199.519531 466.523438 139.203125 373.664062 139.203125 C 280.808594 139.203125 221.296875 192.699219 192.171875 238.8125 Z M 192.171875 238.8125 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial2)"
				},
				d: "M 192.171875 238.8125 C 158.871094 291.535156 114.042969 367.085938 98.914062 390.859375 C 80.929688 419.121094 33.304688 407.113281 37.25 366.609375 C 36.863281 369.894531 36.5625 373.210938 36.355469 376.546875 C 29.84375 481.933594 113.398438 569.453125 217.375 569.453125 C 331.96875 569.453125 605.269531 426.671875 577.609375 283.609375 C 548.457031 199.519531 466.523438 139.203125 373.664062 139.203125 C 280.808594 139.203125 221.296875 192.699219 192.171875 238.8125 Z M 192.171875 238.8125 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial3)"
				},
				d: "M 192.171875 238.8125 C 158.871094 291.535156 114.042969 367.085938 98.914062 390.859375 C 80.929688 419.121094 33.304688 407.113281 37.25 366.609375 C 36.863281 369.894531 36.5625 373.210938 36.355469 376.546875 C 29.84375 481.933594 113.398438 569.453125 217.375 569.453125 C 331.96875 569.453125 605.269531 426.671875 577.609375 283.609375 C 548.457031 199.519531 466.523438 139.203125 373.664062 139.203125 C 280.808594 139.203125 221.296875 192.699219 192.171875 238.8125 Z M 192.171875 238.8125 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial4)"
				},
				d: "M 192.171875 238.8125 C 158.871094 291.535156 114.042969 367.085938 98.914062 390.859375 C 80.929688 419.121094 33.304688 407.113281 37.25 366.609375 C 36.863281 369.894531 36.5625 373.210938 36.355469 376.546875 C 29.84375 481.933594 113.398438 569.453125 217.375 569.453125 C 331.96875 569.453125 605.269531 426.671875 577.609375 283.609375 C 548.457031 199.519531 466.523438 139.203125 373.664062 139.203125 C 280.808594 139.203125 221.296875 192.699219 192.171875 238.8125 Z M 192.171875 238.8125 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial5)"
				},
				d: "M 192.171875 238.8125 C 158.871094 291.535156 114.042969 367.085938 98.914062 390.859375 C 80.929688 419.121094 33.304688 407.113281 37.25 366.609375 C 36.863281 369.894531 36.5625 373.210938 36.355469 376.546875 C 29.84375 481.933594 113.398438 569.453125 217.375 569.453125 C 331.96875 569.453125 605.269531 426.671875 577.609375 283.609375 C 548.457031 199.519531 466.523438 139.203125 373.664062 139.203125 C 280.808594 139.203125 221.296875 192.699219 192.171875 238.8125 Z M 192.171875 238.8125 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#linear0)"
				},
				d: "M 215.699219 569.496094 C 215.699219 569.496094 489.320312 570.035156 535.734375 570.035156 C 619.960938 570.035156 684 501.273438 684 421.03125 C 684 340.789062 618.671875 272.445312 535.734375 272.445312 C 452.792969 272.445312 405.027344 334.492188 369.152344 402.226562 C 327.117188 481.59375 273.488281 568.546875 215.699219 569.496094 Z M 215.699219 569.496094 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial6)"
				},
				d: "M 215.699219 569.496094 C 215.699219 569.496094 489.320312 570.035156 535.734375 570.035156 C 619.960938 570.035156 684 501.273438 684 421.03125 C 684 340.789062 618.671875 272.445312 535.734375 272.445312 C 452.792969 272.445312 405.027344 334.492188 369.152344 402.226562 C 327.117188 481.59375 273.488281 568.546875 215.699219 569.496094 Z M 215.699219 569.496094 "
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "url(#radial7)"
				},
				d: "M 215.699219 569.496094 C 215.699219 569.496094 489.320312 570.035156 535.734375 570.035156 C 619.960938 570.035156 684 501.273438 684 421.03125 C 684 340.789062 618.671875 272.445312 535.734375 272.445312 C 452.792969 272.445312 405.027344 334.492188 369.152344 402.226562 C 327.117188 481.59375 273.488281 568.546875 215.699219 569.496094 Z M 215.699219 569.496094 "
			})
		]
	})]
});
export default SvgMicrosoftOneDriveIcon2025Present;
